<template>
  <div class="container">
    <!-- 数据列表 -->
    <template  v-if="detailStatus == '1' && showPage">
      <swiper class="slider" :options="options">
        <swiper-slide v-for="(item,index) in imgList" :key="index">
          <img :src="item.imgUrl" class="slide_image" @click="viewBigPic(item.imgUrl)" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
      <section class="detail_mess">
        <section class="mess_top">
          <span class="price_i">¥</span>
          <span class="price_text">{{tbOfficeMaterial.price | priceFormat}}</span>
          <span :class="['label',tbOfficeMaterial.serviceType==0?'':'more_time']">{{tbOfficeMaterial.serviceType | serviceType}}</span>
          <img @click="showIframe = true" src="../../assets/images/icon_share.png" class="icon_share">
        </section>
        <h2 class="title">{{tbOfficeMaterial.name}}</h2>
        <p class="num">库存数量:{{kcQuantity}}</p>
      </section>
      <template v-if="tbOfficeMaterial.descr">
        <section class="shop_detail_title">
          <span class="line"></span>
          <span class="text">商品详情</span>
          <span class="line"></span>
        </section>
        <div class="viewhtml" v-html="tbOfficeMaterial.descr"></div>
      </template>
      <common-footer class="button">
        <p class="footer_btn btn_default" @click="buySubmit">立即购买</p>
      </common-footer>
    </template>
    <div v-if="detailStatus != '1' && showPage" class="noMess">
      <img src="../../assets/images/img_unpublish.png"/>
      <span>该办公耗材已下架</span>
    </div>
    <!-- 查看大图 -->
    <fade-animation>
      <common-gallary
        :imgs="imgsArr"
        v-show="showGallary"
        :curIndex="curIndex"
        @close="showGallary = false"
      ></common-gallary>
    </fade-animation>
    <share-iframe :showIframe="showIframe" @hideIframe="showIframe = false"></share-iframe>
  </div>
</template>

<script>
import { getOfficeMaterialById} from '../../utils/api';
import util from '../../utils/util';
import ShareIframe from '../../components/shareIframe';
import commonFooter from '../../components/commonFooter';
import { mapState } from 'vuex';
import CommonGallary from '../../components/Gallary'
import FadeAnimation from '../../components/FadeAnimation'
 import wx from 'weixin-js-sdk'
//import wx from 'jweixin-1.6.0'
export default {
  name: 'officeServiceDetail',
  components: {
    commonFooter,
    CommonGallary,
    FadeAnimation,
    ShareIframe
  },
  computed: {
    ...mapState({
      common: state => state.common
    })
  },
  data () {
    return {
      imgList:[],//轮播图
      imgsArr:[],//查看轮播图
      kcQuantity:'',//库存数量
      tbOfficeMaterial:{},//详情页数据
      showIframe:false,
      showGallary:false,
      showPage:false,
      curIndex:0,
      detailStatus:'1',//0结束 1启用 2暂停
      options: {
        pagination: ".swiper-pagination",
        paginationType: "bullets",
        autoplay: 3000,
        speed: 1000,
        loop:false
      }
    };
  },
  created () {
    this.getOfficeMaterialById()
  },
  filters: {
    serviceType(val){
      if(val == '0'){
        return '一次性送货'
      }else{
        return '多次送货服务'
      }
    }
  },
  methods: {
    getOfficeMaterialById(){
      util.showLoading()
      getOfficeMaterialById({materialId:this.$route.query.id}).then(res=>{
        console.log(res)
        this.showPage = true
        util.hideLoading()
        if(res.res.code === 10000 && res.body && res.body.tbOfficeMaterialOutput){
          this.imgList = res.body.tbOfficeMaterialOutput.imgList || [];
          this.tbOfficeMaterial = res.body.tbOfficeMaterialOutput.tbOfficeMaterial || {};
          let sold = this.tbOfficeMaterial.sold || 0;
          this.detailStatus = this.tbOfficeMaterial.status
          this.kcQuantity = this.tbOfficeMaterial.stock - sold
          // 初始化微信分享
          this.shareFun()
        }else{
          util.showToast(res.res.msg)
        }
      })
    },
    viewBigPic (pic) {
      let arrImg = [];
      let curIndex = 0;
      this.imgList.forEach((item,index)=>{
        arrImg.push(item.imgUrl)
        if(pic == item.imgUrl){
          curIndex = index
        }
      })
      this.imgsArr = arrImg;
      this.curIndex = curIndex;
      this.showGallary = true;
    },
    shareFun(){
      let that = this;
      let address = window.location.href.split('?')[0];
      wx.ready(()=>{
        let obj = {
          title: this.tbOfficeMaterial.name, // 分享标题
          desc: '价格:'+this.tbOfficeMaterial.price+';库存:'+this.kcQuantity,
          link: address+'?id='+this.$route.query.id+'&marketId='+this.common.marketInfo.id+'&cityId='+that.common.cityId, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: this.tbOfficeMaterial.imgUrl,// 分享图标
          success:function(){
            that.showIframe = false
            util.showToast('已分享')
          }
        }
        wx.onMenuShareAppMessage(obj)
        wx.onMenuShareTimeline(obj)
      })
    },
    buySubmit(){
      if (!this.common.userId) {
        this.$router.push({
          path: "/login"
        });
      } else {
        if (Object.keys(this.common.userTenantInfo).length > 0) {
          if(this.kcQuantity <= 0){
            util.showToast('库存不足')
            return;
          }
          this.$router.push(`/officeConfirmOrder?id=${this.tbOfficeMaterial.id}`)
        } else {
          util.showModal("","你未认证企业,无法购买",true,"去认证",() => {
              this.$router.push("/companyList");
            }
          );
        }
      }
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.slider{
  height:562px;
}
.slide_image{
  width:100%;
  height:100%;
}
// detail_mess
.detail_mess{
  background:#fff;
  border-bottom:14px solid #eee;
  .mess_top{
    .flex();
    position: relative;
    padding:0 28px;
    height:94px;
    align-items: center;
    .price_i{
      font-size:32px;
      margin-right:5px;
      color:#F6431C;
    }
    .price_text{
      font-size:44px;
      margin-right:28px;
      color:#F6431C;
    }
    .label{
      padding:0 6px;
      height:36px;
      background:rgba(255,240,225,1);
      border-radius:4px;
      font-size:24px;
      color:rgba(255,126,30,1);
      line-height:36px;
    }
    .more_time{
      background:#def5ed;
      color:#16bc84;
    }
    .icon_share{
      position: absolute;
      top:0;right:0;
      padding:25px 28px;
      height:44px;
      width:44px;
      z-index:2;
    }
  }
  .title{
    font-size:32px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:50px;
    padding:0 28px 20px;
  }
  .num{
    height:40px;
    font-size:28px;
    color:rgba(102,102,102,1);
    line-height:40px;
    padding:0 28px 28px;
  }
}
.shop_detail_title{
  height:88px;
  .flex();
  align-items: center;
  justify-content: center;
  .line{
    width:70px;
    height:2px;
    background:#c9c9c9;
  }
  .text{
    padding:0 20px;
    color:#666;
    font-size:28px;
  }
}
.footer_btn{
  width:100%;
  height:76px;
  line-height: 76px;
  .btn();
}
.noMess{
  .flex();
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height:90vh;
  img{
    display:block;
    width:280px;
    height:280px;
    margin-bottom:28px;
  }
  span{
    color:#999;
    font-size:32px;
    line-height:44px;
  }
}
/deep/ .swiper-pagination {
  color: #000;
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0.2rem;
  display: inline-block;
  text-align: center;
  height: 0.44rem;
  line-height: 0.44rem;
  color: #fff;
  font-size: 0.24rem;
  .flex();
  justify-content: center;
  align-items: center;
  // background: rgba(0, 0, 0, 0.5);
  border-radius: 0.04rem;
  .swiper-pagination-current {
    // font-size: 0.28rem !important;
  }
  .swiper-pagination-bullet-active{ //指示点的颜色
    background: #fff;
    opacity: 1;
  }
}
.viewhtml {
  padding: 40px 28px;
  /deep/ strong {
    font-weight: bold;
    .fontSize(15px);
    line-height: 50px;
  }
  /deep/ p {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ span {
    .fontSize(14px);
    color: rgba(0, 0, 0, 0.9);
    line-height: 40px;
  }
  /deep/ img {
    max-width: 100%;
    min-width: 40%;
    margin: 10px auto;
    height: auto;
    display: block;
  }
  /deep/ figcaption {
    text-align: center;
    .fontSize(14px);
    line-height: 50px;
  }
  /deep/ tr,
  td,
  th {
    .fontSize(14px);
  }
}
</style>